import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from "react-router-dom";
import { PlusOutlined, CloseOutlined } from '@ant-design/icons';

import {
    Layout,
    Input,
    Row,
    Typography,
    Card,
    Select,
    Collapse,
    Form,
    DatePicker,
    Col,
    Table,
    Divider,
    Button,
    Popconfirm,
    InputNumber,
    Spin
} from "antd";
import cnt from "../../../../../../../services/definedConstant";
import { BOM } from '../../../../../../../services/definedMethod';
import { apiConfig, labelConfig, staticConfig } from "../../../../../group.config";

const { Title } = Typography

const Charges = (props) => {

    const { chargeOptions, setIsLoading,
        session, setChargesValue, selectedCharge, setSelectedCharge,
        chargeTableCount, setChargeTableCount, chargeTableSource, setChargeTableSource,
         handleCollateralAdd, handleSave } = props;


    useEffect(() => {
        handleChargesPayloadData()
    }, [chargeTableCount]);


    const handleDelete = (key) => {
        const newData = chargeTableSource.filter((item) => item.key !== key);
        setChargesValue(newData);
        setChargeTableSource(newData);
    };

    const defaultChargesColumns = [
        {
            title: "Name",
            dataIndex: "name",
        },
        {
            title: "Type",
            dataIndex: "type",
        },

        {
            title: "Amount",
            dataIndex: "amount",
            render: (_, record) => {
                return (
                    <Form.Item
                        name={`amount${record.key}`}
                        initialValue={record.amount}
                    >
                        <InputNumber />
                    </Form.Item>
                );
            },
        },

        {
            title: "Collected On",
            dataIndex: "collectedOn",
        },

        {
            title: "Date",
            dataIndex: "date",
            render: (_, record) => (
                <Form.Item
                    name={`dueDate${record.key}`}
                    initialValue={record.dueDate}
                >
                    <DatePicker />
                </Form.Item>
            )
        },

        {
            title: "Actions",
            dataIndex: "actions",
            render: (_, record) =>
                chargeTableSource.length >= 1 ? (
                    <Popconfirm
                        title="Sure to delete?"
                        onConfirm={() => handleDelete(record.key)}
                        okText="OK"
                        cancelText="Cancel"
                        okButtonProps={{
                            style: {
                                backgroundColor: "#15CCAE",
                                color: "white",
                                height: "15%",
                                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                            },
                        }}
                        cancelButtonProps={{
                            style: {
                                height: "15%",
                                backgroundColor: "white",
                                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                            },
                        }}
                    >
                        <CloseOutlined
                            style={{
                                color: "#92428B",
                                fontSize: "15px",
                                fontWeight: "bolder",
                            }}
                        />
                    </Popconfirm>
                ) : null,
        },
    ];

    const chargesColumns = defaultChargesColumns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                editable: col.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave,
            }),
        };
    });

    const handleSelectedCharge = (chargeId) => {
        console.log(chargeId);
        setSelectedCharge(chargeId);
    };


    const handleChargesPayloadData = () => {

        let chargesPayLoadData = [];

        chargeTableSource.forEach((element) => {
            chargesPayLoadData.push({
                id: element.id,
                chargeId: element.chargeId,
                amount: element.amount
            });
        });

        setChargesValue(chargesPayLoadData);
    }


    const handleChargesAdd = () => {

        const url = `${apiConfig.Charges}/${selectedCharge}?template=true`;

        const body = {
            session,
        };

        setIsLoading(true);

        BOM.FetchReqAction(
            body, url, (err, res) => {
                if (err) {
                    BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
                } else {
                    const objList = res;

                    const handleAdd = () => {
                        const newData = {
                            key: chargeTableCount,
                            id: objList?.id ? objList?.id : "-",
                            name: objList?.name ? objList?.name : "-",
                            type: objList?.chargeCalculationType?.value ? objList?.chargeCalculationType?.value : "-",
                            amount: objList?.amount,
                            collectedOn: objList?.chargeTimeType?.value ? objList?.chargeTimeType?.value : "-",
                        };
                        setChargeTableSource([...chargeTableSource, newData]);
                        setChargeTableCount(chargeTableCount + 1);

                    };

                    handleAdd();

                    // STOP LOAD
                    setIsLoading(false);
                }
            }
        );
    };



    return (

        <>
            <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={labelConfig.charge} name={"chargeId"}>
                    <Select
                        placeholder={BOM.handlePlaceholderMsg(
                            `${labelConfig.charge}`,
                            "select"
                        )}
                        options={chargeOptions}
                        onChange={handleSelectedCharge}
                    />
                </Form.Item>
            </Col>

            <Col span={8} style={{ padding: "0px 8px" }}>

                <Form.Item>
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        shape='round'
                        style={{
                            backgroundColor: "#15CCAE",
                            color: "white",
                            width: "15vh",
                            marginTop: 30,
                        }}
                        onClick={handleChargesAdd}
                    >
                        Add
                    </Button>
                </Form.Item>
            </Col>
            <Col span={8}>
                <div></div>
            </Col>

            <Divider orientation="left" orientationMargin="0"><Title level={5} style={{ margin: 0, marginBottom: 0 }}>{labelConfig.selectedCharges}</Title></Divider>

            <Col span={24} style={{ padding: "0px 8px" }}>
                <Table columns={chargesColumns} dataSource={chargeTableSource}></Table>

            </Col>
        </>
    )
}

export default Charges